import React from "react"
import { Link } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { StaticQuery, graphql } from "gatsby"
import Pagination from "../components/pagination"
import { Remarkable } from 'remarkable';
var md = new Remarkable();

const Training_and_Development = () => (

    <StaticQuery query={training_and_detail} render={data=>{     
        console.log(data)
          return (  
  
         
        <div>
        
          <Layout>
               <SEO title="trainging and developement" /> 
          
               <section id="blog" class="section-1 showcase blog-grid filter-section projects">
            <div class="overflow-holder">
              
                <div class="container">
               
                    <div class="row items filter-items">

                    {data.allMarkdownRemark.edges.map((tag,index) => ( 
                        <div class="col-12 col-md-6 col-lg-4 item filter-item" data-groups='["innovation","social","technology"]'>
                            <div class="row card p-0 text-center">
                                <div class="image-over">
                                    <img src=""/>
                                </div>
                                <div class="card-footer d-lg-flex align-items-center justify-content-center">
                                  
                                </div>
                                <div class="card-caption col-12 p-0">
                                    <div class="card-body">
                                       
                                        <Link to={tag.node.fields.slug}>
                                            <h4>{tag.node.frontmatter.name }</h4>
                            
                                            <div dangerouslySetInnerHTML={{__html:md.render(tag.node.frontmatter.description).substring(0,200)}}></div>
                                        
                                         </Link>
                
                                    </div>
                                </div>
                            </div>
                        </div> 
                         ))}
    
                      
                     
                </div>
                    

               
                
                </div>
            </div>
        </section>
  
  
  
  </Layout>
  </div>
          
           )
         }}/>
         )


  const training_and_detail = graphql`
  query training_and_detail{
    allMarkdownRemark(filter: {fileAbsolutePath: {regex: "posts/resources/training_and_development/"}} 
    ) {
      edges {
        node {
          id
          frontmatter {
              name
              description
          }
          fields{
            slug
          }
         
        }
      }
    }
  }
  
   `

  export default Training_and_Development